import { Endpoints } from '@/api/ApiEndpoints';
import { formatDate } from "@/core/helpers/DatetimeConverter";
const d = new Date();
const month = d.getMonth()+1 as any;
const lastDayOfMonth = new Date(d.getFullYear(), d.getMonth()+1, 0);

const Games = {
	Plural: 'Games',
	Single: 'Game',
	DefaultSorting: 'GameDate',
	DefaultSortingType: 'desc',
	RenderAsLeagueGrid: true,
	ModalForm: false,
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'providerId',
			dbName: 'providerId',
			label: 'providerId',
			sortable: true,
			required: true,
			type: 'text',
		},
		
		{
			name: 'homeTeamName',
			label: 'Home Team',
			required: true,
			type: 'text',
			
		},
		{
			name: 'awayTeamName',
			label: 'Away Team',
			required: true,
			type: 'text'
		},
		{
			name: 'leagueName',
			label: 'League Name',
			required: true,
			type: 'text'
		},
		{
			name: 'gameDate',
			dbName: 'gameDate',
			label: 'Game date',
			sortable: true,
			type: 'date',
			format:(item) => {
				return formatDate(item.gameDate);
			}
			
		}
	],
	InitialFilters:
	{

		GameStatus:{
			value:"InPlay",
			valueText:"InPlay",
			clear:null,
			type:"object",
		},
		StartTime:{
			clear:null,
			type:"object",
			
			value:[d.getFullYear()+"-"+month+"-"+d.getDate()],
			valueText:"",
		},
	},
	Filters: [
		{
			name: 'GameStatus',
			label: 'Status',
			nameToRequest: 'GameStatus',
			type: 'radioButtonWithStaticValues',
			attributes: {
				type: 'staticValue',
				values:['InPlay','NotStarted','Finished']				
			},
		},
		{
			name: 'StartTime',
			label: 'Date',
			nameToRequest: 'StartTime', 
			type: 'date',
			valueType: "text",
			mapping: (response) => {
				return response;
			},
		},
	],
	PrimaryKey: 'providerId',
	Actions: {
		addLink: '/games/add/',
		editLink: '/games/edit/',
		deleteLink: true,
	},
};

export default Games;